<template>
    <octicon
        :name="name"
        :aria-hidden="hidden ? true : undefined"
        :scale="scale"
    />
</template>

<script>
// @see https://primer.style/design/foundations/icons
import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons'

export default {
    components: { Octicon },

    props: {
        name: { type: String, required: true },
        hidden: { type: Boolean, default: false },
        scale: { type: Number, default: 1 },
        // scale, flip, spin
    },
}
</script>
